module.exports = __webpack_public_path__ + "media/img/slider1-2de4f8570b36f7974245384cf0addc48.jpg";